import { makes } from 'client/data/constants/active-makes';
import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: `/price-checker/`,
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "price-checker" */ '../pages/price-checker/price-checker-definition')
    ),
    chunkName: 'price-checker',
    resolveLocationInParallelToPagePreload: true,
  },
  {
    path: `/:make(${makes.join('|')})/:model/:year/set-your-price`,
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "set-your-price" */ '../pages/set-your-price/set-your-price-definition')
    ),
    chunkName: 'set-your-price',
    resolveLocationInParallelToPagePreload: true,
  },
];
